import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

const SuccessBox = ({ title, text, callback, showButton = true }) => {
  const {t:translate} = useTranslation();

  return (
    <div className="signup__success">
      <svg
        className="checkmark"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 52 52"
      >
        <circle
          className="checkmark__circle"
          cx="26"
          cy="26"
          r="25"
          fill="none"
        />
        <path
          className="checkmark__check"
          fill="none"
          d="M14.1 27.2l7.1 7.2 16.7-16.8"
        />
      </svg>
      {title && <h1>{title}</h1>}
      {text && <p>{text}</p>}
      {showButton && (
        <div className="button landing-button" onClick={callback}>
          <span>{translate('continue')}</span>{' '}
          <FontAwesomeIcon icon={faChevronRight} size="1x" />
        </div>
      )}
    </div>
  );
};

export default SuccessBox;
